import React from "react";

const WaveLines = () => (
  <svg
    width={1977.69}
    height={622.85}
    viewBox="0 0 1977.69 622.85"
    overflow="visible"
  >
    <style>
      {
        ".waveLines__st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10; opacity: .4}"
      }
    </style>
    <g>
      <path
        className="waveLines__st0 itemTo drawIn"
        style={{ animationDelay: `1s` }}
        d="M.31 589.94s191.28 44.99 489.5-406.53c218.95-331.51 600.33-147.48 825.04 43.35 173.93 147.7 565.98-7.12 662.45-122.75"
      />
      <path
        className="waveLines__st0 itemTo drawIn"
        style={{ animationDelay: `2s` }}
        d="M.31 589.94s190.2 72.37 509.54-366.23c230.42-316.47 580.29-187.78 805.01 3.05 173.93 147.7 565.98 37.24 662.45-78.38"
      />
      <path
        className="waveLines__st0 itemTo drawIn"
        style={{ animationDelay: `3s` }}
        d="M.31 589.94s230.63 78.81 556.42-355.03c210.59-280.43 547.88-179.3 769.04-1.09 177.68 143.18 495.79 75.6 651.54-36.35"
      />
      <path
        className="waveLines__st0 itemTo drawIn"
        style={{ animationDelay: `4s` }}
        d="M.31 589.94S249.89 699.26 580.8 269.16c203.08-263.95 534.58-205.52 755.74-27.32 177.68 143.18 485.02 107.62 640.77-4.33"
      />
      <path
        className="waveLines__st0 itemTo drawIn"
        style={{ animationDelay: `5s` }}
        d="M.31 589.94S268.27 737.49 605.8 310.32c206.47-261.3 515.41-237.51 739.86-61.5 179.56 140.81 475.9 141.8 631.65 29.86"
      />
      <path
        className="waveLines__st0 itemTo drawIn"
        style={{ animationDelay: `6s` }}
        d="M.31 589.94c1.25-.97 298.79 164.69 640.16-244 233.48-279.53 513.91-249.76 739.38-74.04 179.98 140.27 441.71 160.23 597.46 48.28"
      />
    </g>
  </svg>
);

export default WaveLines;
